import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ConfirmationModal } from 'transfix-ui'
import {
  closeDeleteCostControlConfigModal,
  deleteCostControlConfig,
} from '../utils/actions/costControlConfig'
import {
  selectConfigToDelete,
  selectDeleteModalOpen,
  selectCostControlConfigSaving,
  selectCostControlConfigError,
} from '../utils/reducers/costControlConfig'

export const DeleteCostControlConfigModal = () => {
  const dispatch = useDispatch()
  const modalOpen = useSelector(selectDeleteModalOpen)
  const error = useSelector(selectCostControlConfigError)
  const configToDelete = useSelector(selectConfigToDelete)
  const saving = useSelector(selectCostControlConfigSaving)
  const closeModalHandler = () => {
    dispatch(closeDeleteCostControlConfigModal())
  }
  const deleteConfig = () => {
    dispatch(deleteCostControlConfig(configToDelete?.id))
  }

  return (
    <ConfirmationModal
      title='Delete Rule?'
      size={4}
      open={modalOpen}
      error={error}
      onClose={closeModalHandler}
      dataTest='modal-delete-cost-control-config'
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          dataTest: 'cancel-delete-cost-control-config-button',
          disabled: saving,
        },
        {
          label: 'Delete Rule',
          type: 'confirm',
          action: deleteConfig,
          dataTest: 'delete-cost-control-config-button',
          disabled: saving,
        },
      ]}>
      This action cannot be undone
    </ConfirmationModal>
  )
}
